<template>
  <div
    :id="'qrcode_'+id"
    class="qr-code-wrapper"
    :style="{ width: width, height: height }"
  />
</template>

<script>
// eslint-disable-next-line import/named
import { qrcode } from '@core/utils/utils'

export default {
  props: {
    id: {
      type: String,
      default: () => '',
    },
    width: {
      type: String,
      default: () => '100px',
    },
    height: {
      type: String,
      default: () => '100px',
    },
  },
  mounted() {
    this.codeGenerator(this.id)
  },
  methods: {
    async codeGenerator(waybill) {
      qrcode(`qrcode_${waybill}`, waybill)
    },
  },
}
</script>
<style scoped>
.qr-code-wrapper ::v-deep img,
.qr-code-wrapper ::v-deep canvas {
  width: 100% !important;
  height: 100% !important;
  object-fit: contain;
  display: block;
}
</style>
